/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import { withDebugMetadata } from '@/utils/withDebugMetadata';
import { withLabradorInstanceof } from '@/utils/withInstanceofProp';
import { LabradorTagsIndex as ResolvedLabradorTagsIndex } from 'base/components/labrador/TagsIndex';

export const LabradorTagsIndex: typeof ResolvedLabradorTagsIndex = withLabradorInstanceof((props) => {
    return <ResolvedLabradorTagsIndex {...props} {...withDebugMetadata({type: props.type, meta: props.meta})} />;
});

export type LabradorTagsIndexProps = PropsFromComponent<typeof LabradorTagsIndex>;
